import {LoggingService} from "logging/LoggingService";

export function InactiveCreScormApi(){

    const logId = "InactiveCreScormApi";

    // revealing public api
    return {

        /***********************************************************************
         initializes the communication with the course
         @param {String} parameter does nothing, exists due to scorm support
         @return {String} false
         ***********************************************************************/
        LMSInitialize: function (parameter) {
            LoggingService.error( "Initialize(" + parameter + ") called on inactive SCORM api", logId );
            return "false";
        },

        /***********************************************************************
         terminates the communication with the course
         @param {String} parameter does nothing, exists due to scorm support
         @return {String} true / false
         ***********************************************************************/
        LMSFinish: function (parameter) {
            LoggingService.error( "Terminate(" + parameter + ") called on inactive SCORM api", logId );
            return "false";
        },

        /***********************************************************************
         gets a value from course sco repository or the lms
         @param {String} dataModelId scorm data model id for the the value
         @return {String} false
         ***********************************************************************/
        LMSGetValue: function( dataModelId ) {
            LoggingService.error( "GetValue( " + dataModelId + " ) called on inactive SCORM api", logId );
            return "false";
        },

        /***********************************************************************
         sets a value in the course sco repository or the lms
         @param {String} dataModelId scorm data model id for the the value
         @param {String} value value data
         @return {String} false
         ***********************************************************************/
        LMSSetValue: function (dataModelId, value) {
            LoggingService.error( "SetValue( " + dataModelId + ", " + value + " ) called on inactive SCORM api", logId );
            return "false";
        },

        /***********************************************************************
         commits the data to the course
         @param {String} parameter does nothing, exists due to scorm support
         @return {String} true / false
         ***********************************************************************/
        LMSCommit: function (parameter) {
            LoggingService.error( "Commit( " + parameter + " ) called on inactive SCORM api", logId );
            return "false";
        },

        /***********************************************************************
         checks errors for previous calls
         @return {String} 102 - General Initialization Failure
         ***********************************************************************/
        LMSGetLastError: function () {
            LoggingService.error( "GetLastError() called on inactive SCORM api", logId );
            return "102";
        },

        /***********************************************************************
         gets an error message for errors raised in previous calls
         @param {String} errorCode
         @return {String} General Initialization Failure
         ***********************************************************************/
        LMSGetErrorString: function (errorCode) {
            LoggingService.error( "GetErrorString( " + errorCode + " ) called on inactive SCORM api", logId );
            return "General Initialization Failure";
        },

        /***********************************************************************
         gets an diagnostic message for errors raised in previous calls
         @param {String} errorCode
         @return {String} empty string
         ***********************************************************************/
        LMSGetDiagnostic: function (errorCode) {
            LoggingService.error( "GetDiagnostic( " + errorCode + " ) called on inactive SCORM api", logId );
            return "";
        }
    };
}
